export default __webpack_public_path__ + "static/media/screen1.0cba33db.png";